var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,40c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c1.1,0,2.1,0.4,2.8,1.2c1.6,1.6,1.5,4.1,0,5.7C14.1,39.6,13.1,40,12,40z M12,28c-2.2,0-4-1.8-4-4c0-1.1,0.4-2.1,1.2-2.8c1.6-1.6,4.1-1.6,5.7,0c0,0,0,0,0,0c1.6,1.6,1.5,4.1,0,5.7C14.1,27.6,13.1,28,12,28z M12,16c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S14.2,16,12,16z M24,16c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c1.1,0,2.1,0.4,2.8,1.2c1.6,1.6,1.6,4.1,0,5.6C26.1,15.6,25.1,16,24,16z M36,16c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,1.1-0.4,2.1-1.2,2.8C38.1,15.6,37.1,16,36,16z M24,28c-2.2,0-4-1.8-4-4c0-1.1,0.4-2.1,1.2-2.8c1.5-1.6,4.1-1.7,5.7-0.1c1.6,1.5,1.7,4.1,0.1,5.7c0,0-0.1,0.1-0.1,0.1C26.1,27.6,25.1,28,24,28z M26,38v-3.3c0-0.5,0.2-1.1,0.6-1.5L37,22.9c0.3-0.3,0.6-0.5,1-0.6c0.4-0.1,0.7-0.2,1.1-0.2c0.4,0,0.8,0.1,1.2,0.2c0.4,0.2,0.7,0.4,1,0.7l1.8,1.9c0.3,0.3,0.5,0.6,0.6,1c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.8-0.2,1.1c-0.1,0.4-0.4,0.7-0.7,1L32.8,39.4c-0.4,0.4-0.9,0.6-1.5,0.6H28c-1.1,0-2-0.8-2-1.9C26,38.1,26,38,26,38z M41,26.9L39.2,25L41,26.9z M29,37h1.9l6.1-6.1l-0.9-1l-1-0.9l-6.1,6V37z M36,30l-1-0.9l2,1.8L36,30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.658e88fc38b72b7990e5c9c9dce9627b.svg";
export { ForwardRef as ReactComponent };